import { SessionManager } from "../session/SessionManager";
import { CommandProcessor } from "../commands/processors/CommandProcessor";
import { PromptResolver } from "../commands/resolution/PromptResolver";
import { StepProcessor } from "../commands/processors/StepProcessor";
import { RedirectHandler } from "../commands/processors/RedirectHandler";
import { InputHandler } from "../commands/resolution/InputHandler";
import { SessionCoordinator } from "../session/SessionCoordinator";
import { CommandFlowOrchestrator } from "../session/CommandFlowOrchestrator";
import { StepFlowManager } from "../session/StepFlowManager";

export class EngineFactory {
  static createComponents(commands, translations, store) {
    // Core managers
    const sessionManager = new SessionManager();
    const commandProcessor = new CommandProcessor(
      commands,
      translations,
      store
    );
    const promptResolver = new PromptResolver();

    // Specialized processors
    const stepProcessor = new StepProcessor(commandProcessor, promptResolver);
    const redirectHandler = new RedirectHandler(commandProcessor);
    const inputHandler = new InputHandler(
      commandProcessor,
      stepProcessor,
      redirectHandler,
      sessionManager
    );

    // High-level coordinators
    const sessionCoordinator = new SessionCoordinator(sessionManager, store);
    const flowOrchestrator = new CommandFlowOrchestrator(
      sessionManager,
      redirectHandler,
      inputHandler
    );
    const stepFlowManager = new StepFlowManager(
      stepProcessor,
      promptResolver,
      sessionCoordinator,
      redirectHandler
    );

    return {
      sessionManager,
      commandProcessor,
      promptResolver,
      stepProcessor,
      redirectHandler,
      inputHandler,
      sessionCoordinator,
      flowOrchestrator,
      stepFlowManager,
    };
  }
}
